import React, { useState, useEffect } from 'react';
import { Card, Table, Form, Button, Tabs, Tab, Badge } from 'react-bootstrap';
import Pagination from 'react-js-pagination';
import { useQuery, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { HOPDONGNGUYENTAC_API, HOPDONGCHITIET_API, BaseGatewayImage } from '../../../utils/apiUrl';
import { Get, DeleteSingle } from '../../../utils/httpProvider';
import { messageToast, status200, objectShowNumber } from '../../../utils/define';
import { ConfirmModal } from '../../../modules/modal/ConfirmModal';
import HopDongNguyenTacModal from './components/HopDongNguyenTacModal';
import KhoaDaoTaoModal from './components/KhoaDaoTaoModal';
import moment from 'moment';

const HopDongDaoTao = () => {
    const valueSearch = useSelector((state) => state.search.valueSearch);
    const [activeTab, setActiveTab] = useState('contracts');

    // Contract State
    const [contractPage, setContractPage] = useState(1);
    const [contractPageSize, setContractPageSize] = useState(20);
    const [openContractModal, setOpenContractModal] = useState(false);
    const [selectedContract, setSelectedContract] = useState(null);

    // Course (Detailed Contract) State
    const [coursePage, setCoursePage] = useState(1);
    const [coursePageSize, setCoursePageSize] = useState(20);
    const [openCourseModal, setOpenCourseModal] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState(null);

    // Delete Confirmation State
    const [deleteType, setDeleteType] = useState('contract'); // 'contract' or 'course'
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');
    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);

    // --- FETCH CONTRACT DATA ---
    const { data: contractsData, refetch: refetchContracts, isLoading: loadingContracts } = useQuery(
        ['contractsList', contractPage, contractPageSize, valueSearch],
        () => Get(HOPDONGNGUYENTAC_API.GET_PAGING, null, {
            pageIndex: contractPage,
            pageSize: contractPageSize,
            keyword: valueSearch || ''
        }, false),
        { keepPreviousData: true }
    );

    // --- FETCH COURSE DATA ---
    const { data: coursesData, refetch: refetchCourses, isLoading: loadingCourses } = useQuery(
        ['coursesList', coursePage, coursePageSize, valueSearch],
        () => Get(HOPDONGCHITIET_API.GET_PAGING, null, {
            pageIndex: coursePage,
            pageSize: coursePageSize,
            keyword: valueSearch || ''
        }, false),
        { keepPreviousData: true }
    );

    // Reset pagination when search keyword changes
    useEffect(() => {
        setContractPage(1);
        setCoursePage(1);
    }, [valueSearch]);

    // Mutation for deleting
    const deleteContractMutation = useMutation((id) => DeleteSingle(`${HOPDONGNGUYENTAC_API.DELETE_ITEM}/${id}`));
    const deleteCourseMutation = useMutation((id) => DeleteSingle(`${HOPDONGCHITIET_API.DELETE_ITEM}/${id}`));

    const handleDeleteClick = (id, name, type) => {
        setIdWantDelete(id);
        setDeleteType(type);
        setConfirmDelMessage(`Bạn có chắc chắn muốn xóa ${type === 'contract' ? 'hợp đồng nguyên tắc' : 'hợp đồng chi tiết'}: "${name}"?`);
        setOpenConfirmDeleteModal(true);
    };

    const handleConfirmDelete = () => {
        if (!idWantDelete) return;

        const mutation = deleteType === 'contract' ? deleteContractMutation : deleteCourseMutation;
        const refetch = deleteType === 'contract' ? refetchContracts : refetchCourses;

        mutation.mutate(idWantDelete, {
            onSuccess: (res) => {
                if (res.status === status200 || res.status === 201 || res === true || res.id) {
                    toast.success(messageToast.messageToastDeleteSuccess);
                    refetch();
                } else {
                    toast.error(messageToast.messageToastDeleteError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || "Có lỗi xảy ra khi xóa.");
            }
        });

        setOpenConfirmDeleteModal(false);
        setIdWantDelete('');
    };

    const contracts = contractsData?.data?.$values || contractsData?.data || contractsData?.items?.$values || contractsData?.items || [];
    const totalContractRecords = contractsData?.totalRecords || 0;

    const courses = coursesData?.data?.$values || coursesData?.data || coursesData?.items?.$values || coursesData?.items || [];
    const totalCourseRecords = coursesData?.totalRecords || 0;

    const renderDownloadLink = (link, label) => {
        if (!link || link === '-' || link === 'Chưa có' || link === 'null' || link === 'undefined' || String(link).trim() === '') return null;
        const fullUrl = link.startsWith('http') ? link : `${BaseGatewayImage}${link.startsWith('/') ? '' : '/'}${link}`;
        const parts = link.split('/');
        const fileName = parts[parts.length - 1].split('\\').pop();
        return (
            <div className="d-block mb-1" style={{ fontSize: '0.85rem' }}>
                <span className="font-weight-bold text-secondary mr-1">{label}:</span>
                <a href={fullUrl} target="_blank" rel="noopener noreferrer" className="text-success text-truncate" title={fileName} style={{ maxWidth: '180px', display: 'inline-block', verticalAlign: 'middle' }}>
                    <i className="fas fa-file-alt mr-1"></i>{fileName}
                </a>
            </div>
        );
    };

    return (
        <div className="container-fluid p-4">
            <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: '16px' }}>
                <Card.Body className="p-0">
                    <Tabs
                        activeKey={activeTab}
                        onSelect={(k) => setActiveTab(k)}
                        id="contract-course-tabs"
                        className="custom-tabs border-bottom px-3 pt-3 bg-light"
                        style={{ borderTopLeftRadius: '16px', borderTopRightRadius: '16px' }}
                    >
                        {/* TAB 1: HỢP ĐỒNG NGUYÊN TẮC */}
                        <Tab
                            eventKey="contracts"
                            title={<span><i className="fas fa-file-contract mr-2 text-primary"></i>Hợp đồng nguyên tắc</span>}
                        >
                            <div className="p-4">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="font-weight-bold mb-0 text-primary">Quản lý Hợp đồng nguyên tắc</h5>
                                    <Button
                                        variant="success"
                                        onClick={() => { setSelectedContract(null); setOpenContractModal(true); }}
                                        style={{ borderRadius: '8px' }}
                                    >
                                        <i className="fas fa-plus mr-1"></i>Thêm hợp đồng nguyên tắc
                                    </Button>
                                </div>

                                <div className="table-responsive">
                                    <Table striped bordered hover className="align-middle">
                                        <thead className="thead-light">
                                            <tr>
                                                <th style={{ width: '60px' }} className="text-center">STT</th>
                                                <th>Trường thực tập</th>
                                                <th>Số hợp đồng</th>
                                                <th>Tên hợp đồng</th>
                                                <th>Ngày ký hợp đồng</th>
                                                <th>Thời hạn hợp đồng</th>
                                                <th>Ngày kết thúc hợp đồng</th>
                                                <th>Chuyên ngành đào tạo theo HĐ</th>
                                                <th>Liên hệ</th>
                                                <th>Ghi chú</th>
                                                <th className="text-center">Tệp tin</th>
                                                <th style={{ width: '150px' }} className="text-center">Hành động</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loadingContracts ? (
                                                <tr><td colSpan={7} className="text-center py-4">Đang tải dữ liệu...</td></tr>
                                            ) : contracts.length === 0 ? (
                                                <tr><td colSpan={7} className="text-center py-4 text-muted">Chưa có hợp đồng nào</td></tr>
                                            ) : (
                                                contracts.map((item, idx) => (
                                                    <tr key={item.id || item.Id}>
                                                        <td className="text-center">{(contractPage - 1) * contractPageSize + idx + 1}</td>
                                                        <td>{item.truongThucTap?.tenTruong || item.truongThucTap?.TenTruong || item.TruongThucTap?.tenTruong || item.TruongThucTap?.TenTruong || ''}</td>
                                                        <td>{item.soHopDong || item.SoHopDong}</td>
                                                        <td>{item.tenHopDong || item.TenHopDong}</td>
                                                        <td>{(item.ngayKy || item.NgayKy) ? moment(item.ngayKy || item.NgayKy).format('DD/MM/YYYY') : ''}</td>
                                                        <td>{(item.thoiHanHopDong || item.ThoiHanHopDong) ? `${item.thoiHanHopDong || item.ThoiHanHopDong} tháng` : ''}</td>
                                                        <td>{(item.ngayKetThuc || item.ngayKetThuc) ? moment(item.ngayKetThuc || item.ngayKetThuc).format('DD/MM/YYYY') : ''}</td>
                                                        <td>{(item.chuongTrinhDaoTao?.nganhDaoTao?.tenNganh || item.chuongTrinhDaoTao?.nganhDaoTao?.TenNganh || item.chuongTrinhDaoTao?.NganhDaoTao?.tenNganh || item.chuongTrinhDaoTao?.NganhDaoTao?.TenNganh || item.ChuongTrinhDaoTao?.nganhDaoTao?.tenNganh || item.ChuongTrinhDaoTao?.nganhDaoTao?.TenNganh || item.ChuongTrinhDaoTao?.NganhDaoTao?.tenNganh || item.ChuongTrinhDaoTao?.NganhDaoTao?.TenNganh || '')}</td>
                                                        <td>{item.thongTinLienHe || item.ThongTinLienHe || ' '}</td>
                                                        <td>{item.ghiChu || item.GhiChu || ' '}</td>
                                                        <td className="text-center">
                                                            {(item.fileHopDongNguyenTacLink || item.FileHopDongNguyenTacLink) ? (
                                                                <a
                                                                    href={`${BaseGatewayImage}${item.fileHopDongNguyenTacLink || item.FileHopDongNguyenTacLink}`}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                    className="btn btn-outline-info btn-sm"
                                                                    style={{ borderRadius: '6px' }}
                                                                >
                                                                    <i className="fas fa-file"></i>
                                                                </a>
                                                            ) : (
                                                                <span className="text-muted" style={{ fontSize: '0.85rem' }}>Không có</span>
                                                            )}
                                                        </td>
                                                        <td className="text-center">
                                                            <Button
                                                                variant="outline-primary"
                                                                size="sm"
                                                                className="mr-2"
                                                                onClick={() => { setSelectedContract(item); setOpenContractModal(true); }}
                                                                style={{ borderRadius: '6px' }}
                                                            >
                                                                <i className="fas fa-edit"></i>
                                                            </Button>
                                                            <Button
                                                                variant="outline-danger"
                                                                size="sm"
                                                                onClick={() => handleDeleteClick(item.id || item.Id, item.tenHopDong || item.TenHopDong, 'contract')}
                                                                style={{ borderRadius: '6px' }}
                                                            >
                                                                <i className="fas fa-trash-alt"></i>
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </Table>
                                </div>

                                {/* Pagination */}
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    <Form.Control
                                        as="select"
                                        value={contractPageSize}
                                        onChange={(e) => setContractPageSize(Number(e.target.value))}
                                        style={{ width: '100px', borderRadius: '8px' }}
                                    >
                                        {objectShowNumber.map((opt) => (
                                            <option key={opt.value} value={opt.value}>{opt.text}</option>
                                        ))}
                                    </Form.Control>
                                    <Pagination
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        innerClass="pagination pagination-sm no-margin mb-0"
                                        activePage={contractPage}
                                        itemsCountPerPage={contractPageSize}
                                        totalItemsCount={totalContractRecords}
                                        pageRangeDisplayed={5}
                                        onChange={(num) => setContractPage(num)}
                                    />
                                </div>
                            </div>
                        </Tab>

                        {/* TAB 2: HỢP ĐỒNG CHI TIẾT */}
                        <Tab
                            eventKey="courses"
                            title={<span><i className="fas fa-file-signature mr-2 text-primary"></i>Hợp đồng chi tiết</span>}
                        >
                            <div className="p-4">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="font-weight-bold mb-0 text-primary">Quản lý Hợp đồng chi tiết</h5>
                                </div>

                                <div className="table-responsive">
                                    <Table striped bordered hover className="align-middle" style={{ fontSize: '0.9rem' }}>
                                        <thead className="thead-light">
                                            <tr>
                                                <th style={{ width: '50px' }} className="text-center">STT</th>
                                                <th>Trường thực tập</th>
                                                <th>Số hợp đồng</th>
                                                <th>Tên hợp đồng</th>
                                                <th>Thuộc HĐNT</th>
                                                <th>Ngày ký hợp đồng</th>
                                                <th>Ngày kết thúc hợp đồng</th>
                                                <th>Khóa đào tạo</th>
                                                <th style={{ width: '220px' }}>Tệp đính kèm</th>
                                                <th style={{ width: '120px' }} className="text-center">Hành động</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loadingCourses ? (
                                                <tr><td colSpan={10} className="text-center py-4">Đang tải dữ liệu...</td></tr>
                                            ) : courses.length === 0 ? (
                                                <tr><td colSpan={10} className="text-center py-4 text-muted">Chưa có hợp đồng chi tiết nào</td></tr>
                                            ) : (
                                                courses.map((item, idx) => {
                                                    const rawSchool = item.truongThucTapTen || item.TruongThucTapTen || item.hopDongNguyenTac?.truongThucTap?.tenTruong || item.hopDongNguyenTac?.truongThucTap?.TenTruong || '';
                                                    const schoolName = (rawSchool === '-' || rawSchool === 'Chưa có') ? '' : rawSchool;
                                                    
                                                    const ntSoHopDong = item.hopDongNguyenTacSoHopDong || item.HopDongNguyenTacSoHopDong || item.hopDongNguyenTac?.soHopDong || item.hopDongNguyenTac?.SoHopDong || '';
                                                    const rawNtNgayKy = item.hopDongNguyenTacNgayKy || item.HopDongNguyenTacNgayKy || item.hopDongNguyenTac?.ngayKy || item.hopDongNguyenTac?.NgayKy;
                                                    const ntNgayKy = rawNtNgayKy ? moment(rawNtNgayKy).format('DD/MM/YYYY') : '';
                                                    
                                                    const dateStart = (item.ngayKy || item.NgayKy) ? moment(item.ngayKy || item.NgayKy).format('DD/MM/YYYY') : '';
                                                    const dateEnd = (item.ngayKetThuc || item.NgayKetThuc) ? moment(item.ngayKetThuc || item.NgayKetThuc).format('DD/MM/YYYY') : '';

                                                    return (
                                                        <tr key={item.id || item.Id}>
                                                            <td className="text-center">{(coursePage - 1) * coursePageSize + idx + 1}</td>
                                                            <td className="font-weight-bold text-secondary">{schoolName}</td>
                                                            <td className="font-weight-bold text-dark">{item.soHopDong || item.SoHopDong}</td>
                                                            <td>{item.tenHopDong || item.TenHopDong}</td>
                                                            <td>
                                                                <div className="font-weight-bold text-primary">{ntSoHopDong}</div>
                                                                {ntNgayKy && <small className="text-muted">Ngày ký: {ntNgayKy}</small>}
                                                            </td>
                                                            <td>{dateStart}</td>
                                                            <td>{dateEnd}</td>
                                                            <td>
                                                                <div className="font-weight-bold text-dark">{item.tenKhoaDaoTao || 'CTĐT thực hành'}</div>
                                                                {dateStart && dateEnd && <small className="text-muted">{dateStart} - {dateEnd}</small>}
                                                            </td>
                                                            <td>
                                                                {renderDownloadLink(item.congVanDeNghiLink || item.CongVanDeNghiLink, '1. Đề nghị')}
                                                                {renderDownloadLink(item.fileHopDongChiTietLink || item.FileHopDongChiTietLink, '2. HĐ chi tiết')}
                                                                {renderDownloadLink(item.keHoachThucHanhLink || item.KeHoachThucHanhLink, '3. Kế hoạch')}
                                                                {renderDownloadLink(item.fileNghiemThuLink || item.FileNghiemThuLink, '4. Nghiệm thu')}
                                                                {renderDownloadLink(item.fileThanhLyLink || item.FileThanhLyLink, '5. Thanh lý')}
                                                            </td>
                                                            <td className="text-center">
                                                                <Button
                                                                    variant="outline-primary"
                                                                    size="sm"
                                                                    className="mr-1"
                                                                    onClick={() => { setSelectedCourse(item); setOpenCourseModal(true); }}
                                                                    style={{ borderRadius: '6px' }}
                                                                    title="Sửa"
                                                                >
                                                                    <i className="fas fa-edit"></i>
                                                                </Button>
                                                                <Button
                                                                    variant="outline-danger"
                                                                    size="sm"
                                                                    onClick={() => handleDeleteClick(item.id || item.Id, item.tenHopDong || item.TenHopDong, 'course')}
                                                                    style={{ borderRadius: '6px' }}
                                                                    title="Xóa"
                                                                >
                                                                    <i className="fas fa-trash-alt"></i>
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            )}
                                        </tbody>
                                    </Table>
                                </div>

                                {/* Pagination */}
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    <Form.Control
                                        as="select"
                                        value={coursePageSize}
                                        onChange={(e) => setCoursePageSize(Number(e.target.value))}
                                        style={{ width: '100px', borderRadius: '8px' }}
                                    >
                                        {objectShowNumber.map((opt) => (
                                            <option key={opt.value} value={opt.value}>{opt.text}</option>
                                        ))}
                                    </Form.Control>
                                    <Pagination
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        innerClass="pagination pagination-sm no-margin mb-0"
                                        activePage={coursePage}
                                        itemsCountPerPage={coursePageSize}
                                        totalItemsCount={totalCourseRecords}
                                        pageRangeDisplayed={5}
                                        onChange={(num) => setCoursePage(num)}
                                    />
                                </div>
                            </div>
                        </Tab>
                    </Tabs>
                </Card.Body>
            </Card>

            {/* MODALS */}
            <HopDongNguyenTacModal
                isOpen={openContractModal}
                handleClose={() => { setOpenContractModal(false); setSelectedContract(null); }}
                data={selectedContract}
                refetch={refetchContracts}
            />

            <KhoaDaoTaoModal
                isOpen={openCourseModal}
                handleClose={() => { setOpenCourseModal(false); setSelectedCourse(null); }}
                data={selectedCourse}
                refetch={refetchCourses}
            />

            <ConfirmModal
                isOpen={openConfirmDeleteModal}
                confirmType="delete"
                handleAccept={handleConfirmDelete}
                handleCancel={() => { setOpenConfirmDeleteModal(false); setIdWantDelete(''); }}
                content={confirmDelMessage}
            />
        </div>
    );
};

export default HopDongDaoTao;
